/**
 * @generated SignedSource<<d6391147faf1a1d276fe0c2815d692b4>>
 * @relayHash fce58cf35d7393c1b272821b9dea0da3
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fce58cf35d7393c1b272821b9dea0da3

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type TimelineEventViewType = "ACTIVITY" | "CONVERSATION" | "%future added value";
export type UserNameDisplayConfiguration = "HANDLE" | "NAME_AND_HANDLE" | "%future added value";
export type IssueViewerViewQuery$variables = {
  allowedOwner?: string | null | undefined;
  count?: number | null | undefined;
  hideTimeline?: boolean | null | undefined;
  number: number;
  owner: string;
  repo: string;
  skip?: number | null | undefined;
  tabbedTimeline?: boolean | null | undefined;
  viewType?: TimelineEventViewType | null | undefined;
};
export type IssueViewerViewQuery$data = {
  readonly repository: Result<{
    readonly id: string;
    readonly isOwnerEnterpriseManaged: boolean | null | undefined;
    readonly issue: Result<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"IssueViewerIssue">;
    } | null | undefined, unknown>;
    readonly owner: {
      readonly userNameDisplayConfiguration: UserNameDisplayConfiguration;
    };
  } | null | undefined, unknown>;
  readonly safeViewer: {
    readonly " $fragmentSpreads": FragmentRefs<"IssueViewerViewer">;
  } | null | undefined;
};
export type IssueViewerViewQuery = {
  response: IssueViewerViewQuery$data;
  variables: IssueViewerViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "allowedOwner"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "hideTimeline"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "number"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "owner"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "repo"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "tabbedTimeline"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewType"
},
v9 = [
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "repo"
  },
  {
    "kind": "Variable",
    "name": "owner",
    "variableName": "owner"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "kind": "RequiredField",
  "field": (v10/*: any*/),
  "action": "THROW"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOwnerEnterpriseManaged",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userNameDisplayConfiguration",
  "storageKey": null
},
v14 = [
  {
    "kind": "Variable",
    "name": "number",
    "variableName": "number"
  }
],
v15 = {
  "kind": "Variable",
  "name": "allowedOwner",
  "variableName": "allowedOwner"
},
v16 = {
  "kind": "Variable",
  "name": "skip",
  "variableName": "skip"
},
v17 = {
  "kind": "Variable",
  "name": "viewType",
  "variableName": "viewType"
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v24 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v25 = [
  (v24/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataType",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v28 = [
  (v10/*: any*/),
  (v20/*: any*/),
  (v26/*: any*/),
  (v27/*: any*/)
],
v29 = {
  "kind": "InlineFragment",
  "selections": (v28/*: any*/),
  "type": "IssueFieldText",
  "abstractKey": null
},
v30 = {
  "kind": "InlineFragment",
  "selections": (v28/*: any*/),
  "type": "IssueFieldSingleSelect",
  "abstractKey": null
},
v31 = {
  "kind": "InlineFragment",
  "selections": (v28/*: any*/),
  "type": "IssueFieldMultiSelect",
  "abstractKey": null
},
v32 = {
  "kind": "InlineFragment",
  "selections": (v28/*: any*/),
  "type": "IssueFieldDate",
  "abstractKey": null
},
v33 = {
  "kind": "InlineFragment",
  "selections": (v28/*: any*/),
  "type": "IssueFieldNumber",
  "abstractKey": null
},
v34 = [
  (v10/*: any*/)
],
v35 = {
  "kind": "InlineFragment",
  "selections": (v34/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameWithOwner",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchived",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slashCommandsEnabled",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateReason",
  "storageKey": null
},
v46 = [
  (v18/*: any*/),
  (v21/*: any*/),
  (v10/*: any*/)
],
v47 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v46/*: any*/),
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v20/*: any*/),
    (v47/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v49 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDraft",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": 64
    }
  ],
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": "avatarUrl(size:64)"
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCopilot",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAgent",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v55 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isActor"
},
v56 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isNode"
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileResourcePath",
  "storageKey": null
},
v58 = {
  "kind": "InlineFragment",
  "selections": [
    (v52/*: any*/),
    (v53/*: any*/),
    (v54/*: any*/)
  ],
  "type": "Bot",
  "abstractKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closed",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerDidAuthor",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locked",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileUrl",
  "storageKey": null
},
v63 = [
  (v20/*: any*/)
],
v64 = {
  "kind": "InlineFragment",
  "selections": (v63/*: any*/),
  "type": "User",
  "abstractKey": null
},
v65 = {
  "kind": "InlineFragment",
  "selections": (v63/*: any*/),
  "type": "EnterpriseUserAccount",
  "abstractKey": null
},
v66 = {
  "kind": "InlineFragment",
  "selections": (v63/*: any*/),
  "type": "Mannequin",
  "abstractKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "unfurlReferences",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "bodyHTML",
  "storageKey": "bodyHTML(unfurlReferences:true)"
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodyVersion",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUnpin",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanDelete",
  "storageKey": null
},
v74 = {
  "kind": "Literal",
  "name": "first",
  "value": 25
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "optionId",
  "storageKey": null
},
v77 = [
  (v24/*: any*/),
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "ASC",
      "field": "NAME"
    }
  }
],
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameHTML",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v80/*: any*/),
    (v81/*: any*/)
  ],
  "storageKey": null
},
v83 = [
  (v21/*: any*/)
],
v84 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ReactionGroup",
      "kind": "LinkedField",
      "name": "reactionGroups",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "content",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerHasReacted",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 5
            }
          ],
          "concreteType": "ReactorConnection",
          "kind": "LinkedField",
          "name": "reactors",
          "plural": false,
          "selections": [
            (v40/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                (v18/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v83/*: any*/),
                  "type": "User",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v21/*: any*/),
                    (v52/*: any*/),
                    (v53/*: any*/),
                    (v54/*: any*/)
                  ],
                  "type": "Bot",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v83/*: any*/),
                  "type": "Organization",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v83/*: any*/),
                  "type": "Mannequin",
                  "abstractKey": null
                },
                (v35/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": "reactors(first:5)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Reactable",
  "abstractKey": "__isReactable"
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pendingBlock",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pendingUnblock",
  "storageKey": null
},
v87 = [
  {
    "kind": "Literal",
    "name": "allowSameEnterprise",
    "value": true
  },
  (v15/*: any*/),
  (v74/*: any*/)
],
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUpdate",
  "storageKey": null
},
v89 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "Status"
  }
],
v90 = {
  "alias": null,
  "args": (v87/*: any*/),
  "concreteType": "ProjectV2ItemConnection",
  "kind": "LinkedField",
  "name": "projectItems",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectV2ItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectV2Item",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v10/*: any*/),
            (v37/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectV2",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [
                (v10/*: any*/),
                (v41/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "template",
                  "storageKey": null
                },
                (v88/*: any*/),
                (v22/*: any*/),
                {
                  "alias": null,
                  "args": (v89/*: any*/),
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "field",
                  "plural": false,
                  "selections": [
                    (v18/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v23/*: any*/),
                        (v10/*: any*/),
                        (v20/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ProjectV2SingleSelectFieldOption",
                          "kind": "LinkedField",
                          "name": "options",
                          "plural": true,
                          "selections": [
                            (v10/*: any*/),
                            (v76/*: any*/),
                            (v20/*: any*/),
                            (v78/*: any*/),
                            (v42/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "descriptionHTML",
                              "storageKey": null
                            },
                            (v43/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "type": "ProjectV2SingleSelectField",
                      "abstractKey": null
                    },
                    (v35/*: any*/)
                  ],
                  "storageKey": "field(name:\"Status\")"
                },
                (v59/*: any*/),
                (v19/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasReachedItemsLimit",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v89/*: any*/),
              "concreteType": null,
              "kind": "LinkedField",
              "name": "fieldValueByName",
              "plural": false,
              "selections": [
                (v18/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v10/*: any*/),
                    (v76/*: any*/),
                    (v20/*: any*/),
                    (v78/*: any*/),
                    (v42/*: any*/)
                  ],
                  "type": "ProjectV2ItemFieldSingleSelectValue",
                  "abstractKey": null
                },
                (v35/*: any*/)
              ],
              "storageKey": "fieldValueByName(name:\"Status\")"
            },
            (v18/*: any*/)
          ],
          "storageKey": null
        },
        (v79/*: any*/)
      ],
      "storageKey": null
    },
    (v82/*: any*/)
  ],
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": (v87/*: any*/),
  "filters": [
    "allowedOwner",
    "allowSameEnterprise"
  ],
  "handle": "connection",
  "key": "ProjectSection_projectItems",
  "kind": "LinkedHandle",
  "name": "projectItems"
},
v92 = {
  "kind": "Literal",
  "name": "visibleEventsOnly",
  "value": true
},
v93 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v16/*: any*/),
  (v92/*: any*/)
],
v94 = [
  (v18/*: any*/),
  (v35/*: any*/)
],
v95 = {
  "alias": "issueTitleHTML",
  "args": null,
  "kind": "ScalarField",
  "name": "titleHTML",
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v20/*: any*/),
    (v38/*: any*/),
    (v47/*: any*/)
  ],
  "storageKey": null
},
v97 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v95/*: any*/),
    (v22/*: any*/),
    (v19/*: any*/),
    (v45/*: any*/),
    (v96/*: any*/)
  ],
  "type": "Issue",
  "abstractKey": null
},
v98 = {
  "alias": "pullTitleHTML",
  "args": null,
  "kind": "ScalarField",
  "name": "titleHTML",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInMergeQueue",
  "storageKey": null
},
v100 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v98/*: any*/),
    (v22/*: any*/),
    (v19/*: any*/),
    (v44/*: any*/),
    (v50/*: any*/),
    (v99/*: any*/),
    (v96/*: any*/)
  ],
  "type": "PullRequest",
  "abstractKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "actor",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v55/*: any*/),
    (v51/*: any*/),
    (v21/*: any*/),
    (v57/*: any*/),
    (v58/*: any*/),
    (v64/*: any*/),
    (v65/*: any*/),
    (v66/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "concreteType": "Label",
  "kind": "LinkedField",
  "name": "label",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v78/*: any*/),
    (v20/*: any*/),
    (v42/*: any*/),
    (v43/*: any*/)
  ],
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueUpdateIntent",
  "kind": "LinkedField",
  "name": "intent",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rationale",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resourcePath",
  "storageKey": null
},
v105 = [
  (v21/*: any*/),
  (v104/*: any*/),
  (v20/*: any*/)
],
v106 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "assignee",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v34/*: any*/),
      "type": "User",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v34/*: any*/),
      "type": "Bot",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v34/*: any*/),
      "type": "Mannequin",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v34/*: any*/),
      "type": "Organization",
      "abstractKey": null
    },
    (v35/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v21/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": (v105/*: any*/),
          "type": "User",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v105/*: any*/),
          "type": "Mannequin",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v21/*: any*/),
            (v104/*: any*/)
          ],
          "type": "Organization",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v21/*: any*/),
            (v104/*: any*/),
            (v52/*: any*/),
            (v54/*: any*/),
            (v53/*: any*/)
          ],
          "type": "Bot",
          "abstractKey": null
        }
      ],
      "type": "Actor",
      "abstractKey": "__isActor"
    }
  ],
  "storageKey": null
},
v107 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Milestone",
    "kind": "LinkedField",
    "name": "milestone",
    "plural": false,
    "selections": [
      (v10/*: any*/),
      (v22/*: any*/)
    ],
    "storageKey": null
  },
  (v23/*: any*/),
  (v71/*: any*/),
  (v101/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "milestoneTitle",
    "storageKey": null
  }
],
v108 = [
  (v20/*: any*/),
  (v26/*: any*/)
],
v109 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "issueField",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v108/*: any*/),
      "type": "IssueFieldText",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v108/*: any*/),
      "type": "IssueFieldDate",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v108/*: any*/),
      "type": "IssueFieldNumber",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v108/*: any*/),
      "type": "IssueFieldSingleSelect",
      "abstractKey": null
    },
    (v35/*: any*/)
  ],
  "storageKey": null
},
v110 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "IssueComment",
    "kind": "LinkedField",
    "name": "issueComment",
    "plural": false,
    "selections": [
      (v10/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/)
    ],
    "storageKey": null
  },
  (v23/*: any*/),
  (v71/*: any*/),
  (v101/*: any*/)
],
v111 = [
  (v71/*: any*/),
  (v23/*: any*/),
  (v101/*: any*/)
],
v112 = {
  "kind": "InlineFragment",
  "selections": [
    (v97/*: any*/),
    (v100/*: any*/)
  ],
  "type": "ReferencedSubject",
  "abstractKey": "__isReferencedSubject"
},
v113 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "abbreviatedOid",
  "storageKey": null
},
v114 = [
  (v23/*: any*/),
  (v71/*: any*/),
  (v101/*: any*/)
],
v115 = {
  "kind": "InlineFragment",
  "selections": [
    (v18/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v95/*: any*/),
        (v22/*: any*/),
        (v19/*: any*/),
        (v45/*: any*/),
        (v96/*: any*/)
      ],
      "type": "Issue",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v98/*: any*/),
        (v22/*: any*/),
        (v19/*: any*/),
        (v44/*: any*/),
        (v50/*: any*/),
        (v99/*: any*/),
        (v96/*: any*/)
      ],
      "type": "PullRequest",
      "abstractKey": null
    }
  ],
  "type": "ReferencedSubject",
  "abstractKey": "__isReferencedSubject"
},
v116 = [
  (v10/*: any*/),
  (v115/*: any*/)
],
v117 = [
  (v23/*: any*/),
  (v101/*: any*/),
  (v71/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "blockingIssue",
    "plural": false,
    "selections": (v116/*: any*/),
    "storageKey": null
  }
],
v118 = [
  (v23/*: any*/),
  (v101/*: any*/),
  (v71/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "blockedIssue",
    "plural": false,
    "selections": (v116/*: any*/),
    "storageKey": null
  }
],
v119 = [
  (v23/*: any*/),
  (v10/*: any*/),
  (v115/*: any*/)
],
v120 = [
  (v23/*: any*/),
  (v101/*: any*/),
  (v71/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "subIssue",
    "plural": false,
    "selections": (v119/*: any*/),
    "storageKey": null
  }
],
v121 = [
  (v23/*: any*/),
  (v101/*: any*/),
  (v71/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "parent",
    "plural": false,
    "selections": (v119/*: any*/),
    "storageKey": null
  }
],
v122 = [
  (v23/*: any*/),
  (v101/*: any*/),
  (v71/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "subject",
    "plural": false,
    "selections": [
      (v18/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v41/*: any*/),
          (v22/*: any*/),
          (v19/*: any*/),
          (v44/*: any*/),
          (v50/*: any*/),
          (v99/*: any*/),
          (v48/*: any*/)
        ],
        "type": "PullRequest",
        "abstractKey": null
      },
      (v35/*: any*/)
    ],
    "storageKey": null
  }
],
v123 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v95/*: any*/),
        (v22/*: any*/),
        (v45/*: any*/),
        (v96/*: any*/)
      ],
      "type": "Issue",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v98/*: any*/),
        (v22/*: any*/),
        (v44/*: any*/),
        (v50/*: any*/),
        (v99/*: any*/),
        (v96/*: any*/)
      ],
      "type": "PullRequest",
      "abstractKey": null
    }
  ],
  "type": "ReferencedSubject",
  "abstractKey": "__isReferencedSubject"
},
v124 = [
  (v10/*: any*/),
  (v19/*: any*/),
  (v123/*: any*/)
],
v125 = {
  "kind": "InlineFragment",
  "selections": (v124/*: any*/),
  "type": "Issue",
  "abstractKey": null
},
v126 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCanonicalOfClosedDuplicate",
  "storageKey": null
},
v127 = [
  (v112/*: any*/)
],
v128 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectV2",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v41/*: any*/),
    (v22/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v129 = [
  (v20/*: any*/),
  (v42/*: any*/),
  (v10/*: any*/)
],
v130 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueType",
  "kind": "LinkedField",
  "name": "issueType",
  "plural": false,
  "selections": (v129/*: any*/),
  "storageKey": null
},
v131 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueTimelineItemsEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v18/*: any*/),
        {
          "kind": "TypeDiscriminator",
          "abstractKey": "__isIssueTimelineItems"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v23/*: any*/),
            (v71/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "actor",
              "plural": false,
              "selections": (v46/*: any*/),
              "storageKey": null
            }
          ],
          "type": "TimelineEvent",
          "abstractKey": "__isTimelineEvent"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v23/*: any*/),
            (v60/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Issue",
              "kind": "LinkedField",
              "name": "issue",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "author",
                  "plural": false,
                  "selections": (v46/*: any*/),
                  "storageKey": null
                },
                (v10/*: any*/),
                (v19/*: any*/),
                (v61/*: any*/),
                (v23/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "author",
              "plural": false,
              "selections": [
                (v18/*: any*/),
                (v21/*: any*/),
                (v67/*: any*/),
                (v62/*: any*/),
                (v10/*: any*/),
                (v64/*: any*/),
                (v65/*: any*/),
                (v66/*: any*/)
              ],
              "storageKey": null
            },
            (v10/*: any*/),
            (v68/*: any*/),
            (v69/*: any*/),
            (v70/*: any*/),
            (v88/*: any*/),
            (v22/*: any*/),
            (v71/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "authorAssociation",
              "storageKey": null
            },
            (v73/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanMinimize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanUnminimize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanReport",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanReportToMaintainer",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanBlockFromOrg",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanUnblockFromOrg",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanPin",
              "storageKey": null
            },
            (v72/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "App",
              "kind": "LinkedField",
              "name": "viaApp",
              "plural": false,
              "selections": [
                (v20/*: any*/),
                (v22/*: any*/),
                (v10/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": "isHidden",
              "args": null,
              "kind": "ScalarField",
              "name": "isMinimized",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minimizedReason",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showSpammyBadge",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdViaEmail",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Sponsorship",
              "kind": "LinkedField",
              "name": "authorToRepoOwnerSponsorship",
              "plural": false,
              "selections": [
                (v71/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isActive",
                  "storageKey": null
                },
                (v10/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Repository",
              "kind": "LinkedField",
              "name": "repository",
              "plural": false,
              "selections": [
                (v10/*: any*/),
                (v20/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "owner",
                  "plural": false,
                  "selections": [
                    (v18/*: any*/),
                    (v10/*: any*/),
                    (v21/*: any*/),
                    (v22/*: any*/)
                  ],
                  "storageKey": null
                },
                (v38/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "viewerCanCreateIssues",
                  "storageKey": null
                },
                (v39/*: any*/),
                (v36/*: any*/),
                (v23/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "pinnedBy",
              "plural": false,
              "selections": [
                (v21/*: any*/),
                (v10/*: any*/)
              ],
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "viewerCanReadUserContentEdits",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastEditedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserContentEdit",
                  "kind": "LinkedField",
                  "name": "lastUserContentEdit",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "editor",
                      "plural": false,
                      "selections": [
                        (v18/*: any*/),
                        (v22/*: any*/),
                        (v21/*: any*/),
                        (v10/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v10/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "type": "Comment",
              "abstractKey": "__isComment"
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pendingMinimizeReason",
                  "storageKey": null
                },
                (v85/*: any*/),
                (v86/*: any*/)
              ]
            },
            (v84/*: any*/)
          ],
          "type": "IssueComment",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "source",
              "plural": false,
              "selections": (v94/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "willCloseTarget",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "referencedAt",
              "storageKey": null
            },
            (v23/*: any*/),
            {
              "alias": "innerSource",
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "source",
              "plural": false,
              "selections": [
                (v18/*: any*/),
                {
                  "kind": "TypeDiscriminator",
                  "abstractKey": "__isReferencedSubject"
                },
                (v97/*: any*/),
                (v100/*: any*/),
                (v35/*: any*/)
              ],
              "storageKey": null
            },
            (v101/*: any*/)
          ],
          "type": "CrossReferencedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v102/*: any*/),
            (v23/*: any*/),
            (v71/*: any*/),
            (v101/*: any*/),
            (v103/*: any*/)
          ],
          "type": "LabeledEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v102/*: any*/),
            (v23/*: any*/),
            (v71/*: any*/),
            (v101/*: any*/)
          ],
          "type": "UnlabeledEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v106/*: any*/),
            (v23/*: any*/),
            (v71/*: any*/),
            (v101/*: any*/)
          ],
          "type": "AssignedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v106/*: any*/),
            (v23/*: any*/),
            (v71/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "actor",
              "plural": false,
              "selections": [
                (v18/*: any*/),
                (v21/*: any*/),
                (v55/*: any*/),
                (v51/*: any*/),
                (v57/*: any*/),
                (v58/*: any*/),
                (v64/*: any*/),
                (v65/*: any*/),
                (v66/*: any*/),
                (v10/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "UnassignedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v107/*: any*/),
          "type": "MilestonedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v107/*: any*/),
          "type": "DemilestonedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v109/*: any*/),
            (v23/*: any*/),
            (v101/*: any*/),
            (v71/*: any*/),
            (v75/*: any*/),
            (v42/*: any*/),
            (v103/*: any*/)
          ],
          "type": "IssueFieldAddedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v109/*: any*/),
            (v23/*: any*/),
            (v101/*: any*/),
            (v71/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "newColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "newValue",
              "storageKey": null
            },
            (v103/*: any*/)
          ],
          "type": "IssueFieldChangedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v109/*: any*/),
            (v23/*: any*/),
            (v101/*: any*/),
            (v71/*: any*/),
            (v103/*: any*/)
          ],
          "type": "IssueFieldRemovedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v110/*: any*/),
          "type": "IssueCommentPinnedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v110/*: any*/),
          "type": "IssueCommentUnpinnedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v111/*: any*/),
          "type": "SubscribedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v111/*: any*/),
          "type": "UnsubscribedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v111/*: any*/),
          "type": "MentionedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v23/*: any*/),
            (v71/*: any*/),
            (v45/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "duplicateOf",
              "plural": false,
              "selections": [
                (v18/*: any*/),
                (v112/*: any*/),
                (v35/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "closingProjectItemStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "closer",
              "plural": false,
              "selections": [
                (v18/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v22/*: any*/),
                    (v41/*: any*/)
                  ],
                  "type": "ProjectV2",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v22/*: any*/),
                    (v19/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Repository",
                      "kind": "LinkedField",
                      "name": "repository",
                      "plural": false,
                      "selections": [
                        (v10/*: any*/),
                        (v20/*: any*/),
                        (v47/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "PullRequest",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v22/*: any*/),
                    (v113/*: any*/),
                    (v48/*: any*/)
                  ],
                  "type": "Commit",
                  "abstractKey": null
                },
                (v35/*: any*/)
              ],
              "storageKey": null
            },
            (v101/*: any*/)
          ],
          "type": "ClosedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v114/*: any*/),
          "type": "ReopenedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v23/*: any*/),
            (v71/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lockReason",
              "storageKey": null
            },
            (v101/*: any*/)
          ],
          "type": "LockedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v114/*: any*/),
          "type": "UnlockedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v114/*: any*/),
          "type": "PinnedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v114/*: any*/),
          "type": "UnpinnedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v23/*: any*/),
            (v71/*: any*/),
            (v101/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currentTitle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "previousTitle",
              "storageKey": null
            }
          ],
          "type": "RenamedTitleEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v117/*: any*/),
          "type": "BlockedByAddedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v117/*: any*/),
          "type": "BlockedByRemovedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v118/*: any*/),
          "type": "BlockingAddedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v118/*: any*/),
          "type": "BlockingRemovedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v23/*: any*/),
            (v71/*: any*/),
            (v101/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "deletedCommentAuthor",
              "plural": false,
              "selections": [
                (v18/*: any*/),
                (v21/*: any*/),
                (v64/*: any*/),
                (v66/*: any*/),
                (v65/*: any*/),
                (v10/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "CommentDeletedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v23/*: any*/),
            (v71/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "blockDuration",
              "storageKey": null
            },
            (v101/*: any*/),
            {
              "alias": "blockedUser",
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "subject",
              "plural": false,
              "selections": [
                (v21/*: any*/),
                (v20/*: any*/),
                (v10/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "UserBlockedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v120/*: any*/),
          "type": "SubIssueAddedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v120/*: any*/),
          "type": "SubIssueRemovedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v121/*: any*/),
          "type": "ParentIssueAddedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v121/*: any*/),
          "type": "ParentIssueRemovedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v10/*: any*/),
            (v23/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "willCloseSubject",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "subject",
              "plural": false,
              "selections": (v94/*: any*/),
              "storageKey": null
            },
            (v101/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Commit",
              "kind": "LinkedField",
              "name": "commit",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "message",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "messageHeadlineHTML",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "messageBodyHTML",
                  "storageKey": null
                },
                (v22/*: any*/),
                (v113/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Repository",
                  "kind": "LinkedField",
                  "name": "repository",
                  "plural": false,
                  "selections": [
                    (v20/*: any*/),
                    (v47/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "defaultBranch",
                      "storageKey": null
                    },
                    (v10/*: any*/)
                  ],
                  "storageKey": null
                },
                (v10/*: any*/)
              ],
              "storageKey": null
            },
            (v71/*: any*/)
          ],
          "type": "ReferencedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v122/*: any*/),
          "type": "ConnectedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v23/*: any*/),
            (v101/*: any*/),
            (v71/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Repository",
              "kind": "LinkedField",
              "name": "fromRepository",
              "plural": false,
              "selections": [
                (v36/*: any*/),
                (v22/*: any*/),
                (v10/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "TransferredEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v122/*: any*/),
          "type": "DisconnectedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v101/*: any*/),
            (v71/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "duplicate",
              "plural": false,
              "selections": [
                (v18/*: any*/),
                (v125/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v124/*: any*/),
                  "type": "PullRequest",
                  "abstractKey": null
                },
                (v35/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "canonical",
              "plural": false,
              "selections": [
                (v18/*: any*/),
                (v125/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v19/*: any*/),
                    (v10/*: any*/),
                    (v123/*: any*/)
                  ],
                  "type": "PullRequest",
                  "abstractKey": null
                },
                (v35/*: any*/)
              ],
              "storageKey": null
            },
            (v126/*: any*/),
            (v23/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanUndo",
              "storageKey": null
            },
            (v10/*: any*/),
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pendingUndo",
                  "storageKey": null
                }
              ]
            }
          ],
          "type": "MarkedAsDuplicateEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v101/*: any*/),
            (v71/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "canonical",
              "plural": false,
              "selections": [
                (v18/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v127/*: any*/),
                  "type": "Issue",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v127/*: any*/),
                  "type": "PullRequest",
                  "abstractKey": null
                },
                (v35/*: any*/)
              ],
              "storageKey": null
            },
            (v126/*: any*/),
            (v23/*: any*/)
          ],
          "type": "UnmarkedAsDuplicateEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v23/*: any*/),
            (v101/*: any*/),
            (v71/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Discussion",
              "kind": "LinkedField",
              "name": "discussion",
              "plural": false,
              "selections": [
                (v22/*: any*/),
                (v19/*: any*/),
                (v10/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "ConvertedToDiscussionEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v23/*: any*/),
            (v71/*: any*/),
            (v101/*: any*/),
            (v128/*: any*/)
          ],
          "type": "AddedToProjectV2Event",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v71/*: any*/),
            (v101/*: any*/),
            (v128/*: any*/)
          ],
          "type": "RemovedFromProjectV2Event",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v71/*: any*/),
            (v101/*: any*/),
            (v128/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "previousStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "type": "ProjectV2ItemStatusChangedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v71/*: any*/),
            (v101/*: any*/),
            (v23/*: any*/)
          ],
          "type": "ConvertedFromDraftEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v23/*: any*/),
            (v101/*: any*/),
            (v71/*: any*/),
            (v130/*: any*/),
            (v103/*: any*/)
          ],
          "type": "IssueTypeAddedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v23/*: any*/),
            (v101/*: any*/),
            (v71/*: any*/),
            (v130/*: any*/)
          ],
          "type": "IssueTypeRemovedEvent",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v23/*: any*/),
            (v101/*: any*/),
            (v71/*: any*/),
            (v130/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "IssueType",
              "kind": "LinkedField",
              "name": "prevIssueType",
              "plural": false,
              "selections": (v129/*: any*/),
              "storageKey": null
            },
            (v103/*: any*/)
          ],
          "type": "IssueTypeChangedEvent",
          "abstractKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        },
        (v35/*: any*/)
      ],
      "storageKey": null
    },
    (v79/*: any*/)
  ],
  "storageKey": null
},
v132 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      (v81/*: any*/),
      (v80/*: any*/)
    ],
    "storageKey": null
  },
  (v40/*: any*/),
  (v131/*: any*/)
],
v133 = {
  "kind": "Literal",
  "name": "last",
  "value": 0
},
v134 = [
  (v133/*: any*/),
  (v92/*: any*/)
],
v135 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasPreviousPage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startCursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v40/*: any*/),
  (v131/*: any*/)
],
v136 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 15
  },
  (v17/*: any*/)
],
v137 = [
  "viewType"
],
v138 = [
  (v133/*: any*/),
  (v17/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "IssueViewerViewQuery",
    "selections": [
      {
        "kind": "CatchField",
        "field": {
          "alias": null,
          "args": (v9/*: any*/),
          "concreteType": "Repository",
          "kind": "LinkedField",
          "name": "repository",
          "plural": false,
          "selections": [
            (v11/*: any*/),
            (v12/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "owner",
              "plural": false,
              "selections": [
                (v13/*: any*/)
              ],
              "storageKey": null
            },
            {
              "kind": "CatchField",
              "field": {
                "alias": null,
                "args": (v14/*: any*/),
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "args": [
                      (v15/*: any*/),
                      {
                        "kind": "Variable",
                        "name": "count",
                        "variableName": "count"
                      },
                      {
                        "kind": "Variable",
                        "name": "hideTimeline",
                        "variableName": "hideTimeline"
                      },
                      (v16/*: any*/),
                      {
                        "kind": "Variable",
                        "name": "tabbedTimeline",
                        "variableName": "tabbedTimeline"
                      },
                      (v17/*: any*/)
                    ],
                    "kind": "FragmentSpread",
                    "name": "IssueViewerIssue"
                  }
                ],
                "storageKey": null
              },
              "to": "RESULT"
            }
          ],
          "storageKey": null
        },
        "to": "RESULT"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "safeViewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IssueViewerViewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "IssueViewerViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "Repository",
        "kind": "LinkedField",
        "name": "repository",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              (v13/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v14/*: any*/),
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Repository",
                "kind": "LinkedField",
                "name": "repository",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v21/*: any*/),
                      (v10/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "issueFieldsEnabled",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "name",
                                "value": "issue_fields"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "isFeatureEnabled",
                            "storageKey": "isFeatureEnabled(name:\"issue_fields\")"
                          },
                          {
                            "alias": null,
                            "args": (v25/*: any*/),
                            "concreteType": "IssueFieldsConnection",
                            "kind": "LinkedField",
                            "name": "pinnedIssueFields",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  (v18/*: any*/),
                                  (v29/*: any*/),
                                  (v30/*: any*/),
                                  (v31/*: any*/),
                                  (v32/*: any*/),
                                  (v33/*: any*/),
                                  (v35/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "pinnedIssueFields(first:100)"
                          }
                        ],
                        "type": "Organization",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isWritable",
                    "storageKey": null
                  },
                  (v38/*: any*/),
                  (v23/*: any*/),
                  (v39/*: any*/),
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewerCanPush",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewerCanInteract",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewerInteractionLimitReasonHTML",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCopilotAgentEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 3
                      }
                    ],
                    "concreteType": "PinnedIssueConnection",
                    "kind": "LinkedField",
                    "name": "pinnedIssues",
                    "plural": false,
                    "selections": [
                      (v40/*: any*/)
                    ],
                    "storageKey": "pinnedIssues(first:3)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewerCanPinIssues",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IssueCreationPermissions",
                    "kind": "LinkedField",
                    "name": "viewerIssueCreationPermissions",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "triageable",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v25/*: any*/),
                    "concreteType": "IssueTypeConnection",
                    "kind": "LinkedField",
                    "name": "issueTypes",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IssueTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IssueType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v34/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "issueTypes(first:100)"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              (v41/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "titleHTML",
                "storageKey": null
              },
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanUpdateNext",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  (v42/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isEnabled",
                    "storageKey": null
                  },
                  (v43/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "pinnedFields",
                    "plural": true,
                    "selections": [
                      (v18/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v35/*: any*/),
                      (v31/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v44/*: any*/),
              (v45/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "duplicateOf",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  (v22/*: any*/),
                  (v48/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "linkedPullRequests",
                "args": [
                  (v49/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "includeClosedPrs",
                    "value": false
                  },
                  {
                    "kind": "Literal",
                    "name": "orderByState",
                    "value": true
                  }
                ],
                "concreteType": "PullRequestConnection",
                "kind": "LinkedField",
                "name": "closedByPullRequestsReferences",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PullRequest",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Repository",
                        "kind": "LinkedField",
                        "name": "repository",
                        "plural": false,
                        "selections": [
                          (v36/*: any*/),
                          (v10/*: any*/),
                          (v20/*: any*/),
                          (v47/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v44/*: any*/),
                      (v50/*: any*/),
                      (v22/*: any*/),
                      (v19/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "closedByPullRequestsReferences(first:10,includeClosedPrs:false,orderByState:true)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentAssignment",
                "kind": "LinkedField",
                "name": "agentAssignments",
                "plural": true,
                "selections": [
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Bot",
                    "kind": "LinkedField",
                    "name": "assignee",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v21/*: any*/),
                      (v51/*: any*/),
                      (v52/*: any*/),
                      (v53/*: any*/),
                      (v54/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "assigner",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v55/*: any*/),
                      (v21/*: any*/),
                      (v10/*: any*/),
                      (v56/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "linkedPullRequestsIncludingClosed",
                "args": [
                  (v49/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "includeClosedPrs",
                    "value": true
                  }
                ],
                "concreteType": "PullRequestConnection",
                "kind": "LinkedField",
                "name": "closedByPullRequestsReferences",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PullRequest",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v19/*: any*/),
                      (v22/*: any*/),
                      (v44/*: any*/),
                      (v23/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "closedByPullRequestsReferences(first:10,includeClosedPrs:true)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SubIssuesSummary",
                "kind": "LinkedField",
                "name": "subIssuesSummary",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "completed",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 20
                  }
                ],
                "concreteType": "AssigneeConnection",
                "kind": "LinkedField",
                "name": "assignedActors",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v10/*: any*/),
                          (v21/*: any*/),
                          (v20/*: any*/),
                          (v57/*: any*/),
                          (v51/*: any*/),
                          (v58/*: any*/)
                        ],
                        "type": "Actor",
                        "abstractKey": "__isActor"
                      },
                      (v35/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "assignedActors(first:20)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Milestone",
                "kind": "LinkedField",
                "name": "milestone",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v41/*: any*/),
                  (v59/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dueOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "progressPercentage",
                    "storageKey": null
                  },
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "closedAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v23/*: any*/),
              (v60/*: any*/),
              (v61/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v55/*: any*/),
                  (v21/*: any*/),
                  (v10/*: any*/),
                  (v62/*: any*/),
                  (v64/*: any*/),
                  (v65/*: any*/),
                  (v66/*: any*/),
                  (v67/*: any*/),
                  (v18/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v52/*: any*/),
                      (v53/*: any*/)
                    ],
                    "type": "Bot",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v68/*: any*/),
              (v69/*: any*/),
              (v70/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanUpdateMetadata",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PinnedIssueComment",
                "kind": "LinkedField",
                "name": "pinnedIssueComment",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "pinnedBy",
                    "plural": false,
                    "selections": (v46/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IssueComment",
                    "kind": "LinkedField",
                    "name": "issueComment",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 700
                          },
                          {
                            "kind": "Literal",
                            "name": "stripBlockElements",
                            "value": false
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "shortBodyHTML",
                        "storageKey": "shortBodyHTML(limit:700,stripBlockElements:false)"
                      },
                      (v71/*: any*/),
                      (v22/*: any*/),
                      (v72/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          (v21/*: any*/),
                          (v67/*: any*/),
                          (v62/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanComment",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanAssign",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanLabel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanSetMilestone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPinned",
                "storageKey": null
              },
              (v73/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanTransfer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanConvertToDiscussion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanLock",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanSetFields",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v74/*: any*/)
                ],
                "concreteType": "IssueFieldValueConnection",
                "kind": "LinkedField",
                "name": "issueFieldValues",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              (v29/*: any*/),
                              (v35/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v75/*: any*/)
                        ],
                        "type": "IssueFieldTextValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              (v30/*: any*/),
                              (v35/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v76/*: any*/),
                          (v20/*: any*/),
                          (v42/*: any*/),
                          (v43/*: any*/)
                        ],
                        "type": "IssueFieldSingleSelectValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              (v31/*: any*/),
                              (v35/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IssueFieldSingleSelectOption",
                            "kind": "LinkedField",
                            "name": "options",
                            "plural": true,
                            "selections": [
                              (v10/*: any*/),
                              (v20/*: any*/),
                              (v42/*: any*/),
                              (v43/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "IssueFieldMultiSelectValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              (v32/*: any*/),
                              (v35/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v75/*: any*/)
                        ],
                        "type": "IssueFieldDateValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              (v33/*: any*/),
                              (v35/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "numberValue",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "type": "IssueFieldNumberValue",
                        "abstractKey": null
                      },
                      (v35/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "issueFieldValues(first:25)"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": (v77/*: any*/),
                    "concreteType": "LabelConnection",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Label",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v42/*: any*/),
                              (v20/*: any*/),
                              (v78/*: any*/),
                              (v43/*: any*/),
                              (v22/*: any*/),
                              (v18/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v79/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v82/*: any*/)
                    ],
                    "storageKey": "labels(first:100,orderBy:{\"direction\":\"ASC\",\"field\":\"NAME\"})"
                  },
                  {
                    "alias": null,
                    "args": (v77/*: any*/),
                    "filters": [
                      "orderBy"
                    ],
                    "handle": "connection",
                    "key": "MetadataSectionAssignedLabels_labels",
                    "kind": "LinkedHandle",
                    "name": "labels"
                  },
                  (v56/*: any*/)
                ],
                "type": "Labelable",
                "abstractKey": "__isLabelable"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v71/*: any*/)
                ],
                "type": "Comment",
                "abstractKey": "__isComment"
              },
              (v84/*: any*/),
              {
                "kind": "ClientExtension",
                "selections": [
                  (v85/*: any*/),
                  (v86/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v90/*: any*/),
                      (v91/*: any*/)
                    ],
                    "type": "Issue",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v90/*: any*/),
                      (v91/*: any*/),
                      (v88/*: any*/)
                    ],
                    "type": "PullRequest",
                    "abstractKey": null
                  }
                ],
                "type": "IssueOrPullRequest",
                "abstractKey": "__isIssueOrPullRequest"
              },
              {
                "condition": "hideTimeline",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "condition": "tabbedTimeline",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "alias": "frontTimelineItems",
                        "args": (v93/*: any*/),
                        "concreteType": "IssueTimelineItemsConnection",
                        "kind": "LinkedField",
                        "name": "timelineItems",
                        "plural": false,
                        "selections": (v132/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": "frontTimelineItems",
                        "args": (v93/*: any*/),
                        "filters": [
                          "visibleEventsOnly",
                          "skip"
                        ],
                        "handle": "connection",
                        "key": "Issue__frontTimelineItems",
                        "kind": "LinkedHandle",
                        "name": "timelineItems"
                      },
                      {
                        "alias": "backTimelineItems",
                        "args": (v134/*: any*/),
                        "concreteType": "IssueTimelineItemsConnection",
                        "kind": "LinkedField",
                        "name": "timelineItems",
                        "plural": false,
                        "selections": (v135/*: any*/),
                        "storageKey": "timelineItems(last:0,visibleEventsOnly:true)"
                      },
                      {
                        "alias": "backTimelineItems",
                        "args": (v134/*: any*/),
                        "filters": [
                          "visibleEventsOnly"
                        ],
                        "handle": "connection",
                        "key": "Issue__backTimelineItems",
                        "kind": "LinkedHandle",
                        "name": "timelineItems"
                      }
                    ]
                  },
                  {
                    "condition": "tabbedTimeline",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": "conversationFrontItems",
                        "args": (v136/*: any*/),
                        "concreteType": "IssueTimelineItemsConnection",
                        "kind": "LinkedField",
                        "name": "timelineItems",
                        "plural": false,
                        "selections": (v132/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": "conversationFrontItems",
                        "args": (v136/*: any*/),
                        "filters": (v137/*: any*/),
                        "handle": "connection",
                        "key": "Issue__conversationFrontItems",
                        "kind": "LinkedHandle",
                        "name": "timelineItems"
                      },
                      {
                        "alias": "conversationBackItems",
                        "args": (v138/*: any*/),
                        "concreteType": "IssueTimelineItemsConnection",
                        "kind": "LinkedField",
                        "name": "timelineItems",
                        "plural": false,
                        "selections": (v135/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": "conversationBackItems",
                        "args": (v138/*: any*/),
                        "filters": (v137/*: any*/),
                        "handle": "connection",
                        "key": "Issue__conversationBackItems",
                        "kind": "LinkedHandle",
                        "name": "timelineItems"
                      }
                    ]
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "safeViewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEnterpriseManagedUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enterpriseManagedEnterpriseId",
            "storageKey": null
          },
          (v21/*: any*/),
          (v10/*: any*/),
          (v20/*: any*/),
          (v51/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v18/*: any*/),
              (v57/*: any*/),
              (v58/*: any*/)
            ],
            "type": "Actor",
            "abstractKey": "__isActor"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "fce58cf35d7393c1b272821b9dea0da3",
    "metadata": {},
    "name": "IssueViewerViewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d621380e0cac3218a9f2edd053ccbe7d";

export default node;
